import b from 'b_';
import cx from 'classnames';
import React from 'react';

enum DIRECTIONS {
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right',
}

interface Props {
    direction: DIRECTIONS;
    mix?: string;
}

import './icon__arrow.scss';

const IconTypeArrow = ({ direction, mix }: Props) => (
    <svg
        className={cx(b('icon', 'arrow', { direction }), mix)}
        fill="none"
        height="8"
        viewBox="0 0 14 8"
        width="14"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7 5.58252L11.7931 0.792654C12.1838 0.402263 12.817 0.402479 13.2073 0.793136C13.5977 1.18379 13.5975 1.81696 13.2069 2.20735L7.70687 7.7036C7.3164 8.0938 6.6836 8.0938 6.29313 7.7036L0.793134 2.20735C0.402477 1.81696 0.402261 1.18379 0.792652 0.793136C1.18304 0.402479 1.81621 0.402263 2.20687 0.792654L7 5.58252Z"
            fill="#006CF0"
        />
    </svg>
);

IconTypeArrow.DIRECTIONS = DIRECTIONS;

export default IconTypeArrow;
